import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-rel-entity-evento-azione',
  templateUrl: './rel-entity-evento-azione.component.html',
  styleUrls: ['./rel-entity-evento-azione.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelEntityEventoAzioneComponent {
  @Input() actionAssociata;
  @Input() eventoAssociato;
  @Output() goToEditRelEntityEventoRischioAzioneMitigatrice = new EventEmitter();
  @Output() deleteAction = new EventEmitter();
  @Output() changeActionState = new EventEmitter();

  // ------------------------------------------------------------------------------------------------------------------------------------------

  constructor() {}

  // ------------------------------------------------------------------------------------------------------------------------------------------

  onEditRelEntityEventoRischioAzioneMitigatrice(relEntityEventoRIschioAzioneMitigatrice) {
    this.goToEditRelEntityEventoRischioAzioneMitigatrice.emit(relEntityEventoRIschioAzioneMitigatrice);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------

  onDeleteAction(azione) {
    this.deleteAction.emit(azione);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------

  async onChangeActionState(stato: 0 | 1 | 2) {
    this.changeActionState.emit(stato);
  }
}
